module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/av321-df8cdf20129e8a3511754001c92a054f.jpg";